/* Nakylo · tiroir panier : jauge animée, minuteur « offre valable pendant », livraison estimée, « Annuler » après suppression.
   S'appuie sur le <cart-drawer> de Dawn. Son contenu est redessiné par Shopify à chaque changement
   (#CartDrawer ou .drawer__inner), donc on se rebranche après chaque rendu. */
(function () {
  var drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  // textes traduits, posés par snippets/cart-drawer.liquid (repli en français)
  function t(cle, repli) { return (window.nkyT && window.nkyT[cle]) || repli; }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var minuteurVert = 0, minuteurDepart = 0, dernierPct = null, retire = null;

  function $(sel) { return drawer.querySelector(sel); }
  function deux(n) { return (n < 10 ? '0' : '') + n; }
  function ouvert() { return drawer.classList.contains('active'); }

  /* ---------- jauge : de « depuis » vers la valeur calculée par Shopify ---------- */
  function jauge(depuis, delai) {
    var j = $('.nky-jauge');
    clearTimeout(minuteurVert); clearTimeout(minuteurDepart);
    if (!j) { dernierPct = null; return; }
    var cible = parseFloat(j.dataset.nkyPct) || 0, ok = cible >= 100;
    var plein = j.querySelector('.nky-jauge__plein'), camion = j.querySelector('.nky-camion');
    dernierPct = cible;
    if (reduce || depuis == null || depuis === cible) { j.classList.toggle('is-ok', ok); return; }
    /* départ posé sans animation, AVANT que le panneau glisse : sinon on verrait l'état précédent */
    [plein, camion].forEach(function (el) { el.style.transition = 'none'; });
    plein.style.width = depuis + '%'; camion.style.left = depuis + '%';
    j.classList.remove('is-ok');
    void plein.offsetWidth;
    [plein, camion].forEach(function (el) { el.style.transition = ''; });
    minuteurDepart = setTimeout(function () {
      plein.style.width = cible + '%'; camion.style.left = cible + '%';
      /* le camion passe au vert en arrivant, pas avant */
      minuteurVert = setTimeout(function () { j.classList.toggle('is-ok', ok); }, 1050);
    }, delai || 20);
  }

  /* ---------- livraison estimée (08/10/2026) : aujourd'hui + N jours ouvrés, dans la langue de la page ---------- */
  function livraison() {
    var el = $('[data-nky-dates-panier]'); if (!el) return;
    var langue = document.documentElement.lang || 'fr', fmt;
    try { fmt = new Intl.DateTimeFormat(langue, { weekday: 'short', day: 'numeric', month: 'short' }); }
    catch (err) { fmt = new Intl.DateTimeFormat('fr', { weekday: 'short', day: 'numeric', month: 'short' }); }
    function ajouter(n) {
      var d = new Date(); d.setHours(12, 0, 0, 0);
      while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) n--; }
      return d;
    }
    el.textContent = fmt.format(ajouter(+el.dataset.min || 5)).replace(/\./g, '');
    el.closest('.nky-livraison-panier').hidden = false;
  }

  /* ---------- timer « panier réservé » (05/10/2026) ----------
     Compte à rebours de 15 min (sessionStorage) qui démarre à l'ouverture du panier. */
  var reserveTic = 0;
  function reserveDepart() {
    try { return parseInt(sessionStorage.getItem('nky-reserve-start'), 10) || 0; } catch (e) { return 0; }
  }
  function reserveInit() {
    if (!reserveDepart()) {
      try { sessionStorage.setItem('nky-reserve-start', String(Date.now())); } catch (e) {}
    }
  }
  function reserveChrono() {
    var r = $('.nky-reserve'); if (!r) return;
    var debut = reserveDepart();
    if (!debut) { reserveInit(); debut = reserveDepart(); }
    var duree = parseInt(r.dataset.duree, 10) || 900;
    var reste = Math.max(0, duree - Math.floor((Date.now() - debut) / 1000));
    var min = Math.floor(reste / 60), sec = reste % 60;
    r.querySelector('.nky-reserve__chrono').textContent = deux(min) + ':' + deux(sec);
    r.hidden = false;
    if (reste <= 0) {
      try { sessionStorage.removeItem('nky-reserve-start'); } catch (e) {}
      reserveInit();
    }
  }
  function demarrerReserve() {
    clearInterval(reserveTic); reserveInit(); reserveChrono();
    if (ouvert()) reserveTic = setInterval(reserveChrono, 1000);
  }

  /* ---------- « Annuler » : on retient ce qui vient d'être retiré ---------- */
  function memoriser(ligne) {
    var input = ligne && ligne.querySelector('.quantity__input');
    if (!input) return;
    var nom = ligne.querySelector('.cart-item__name');
    retire = {
      id: Number(input.dataset.quantityVariantId),
      qte: Math.max(1, parseInt(input.value, 10) || 1),
      nom: nom ? nom.textContent.trim() : t('article', 'L’article')
    };
  }
  drawer.addEventListener('click', function (e) {
    var suppr = e.target.closest('.cart-remove-button');
    var moins = e.target.closest('.quantity__button[name="minus"]');
    var ligne = e.target.closest('.cart-item');
    if (suppr) memoriser(ligne);
    else if (moins && ligne) {
      var input = ligne.querySelector('.quantity__input');
      if (input && parseInt(input.value, 10) <= 1) memoriser(ligne);   /* 1 → 0 retire aussi la ligne */
    }
  }, true);

  function proposerAnnulation() {
    var zone = $('.nky-annuler');
    if (!zone) return;
    if (!retire || !drawer.classList.contains('is-empty')) { zone.hidden = true; return; }
    zone.innerHTML = '';
    var texte = document.createElement('span');
    texte.textContent = t('retire', '« %s » a été retiré du panier.').replace('%s', retire.nom) + ' ';
    var bouton = document.createElement('button');
    bouton.type = 'button'; bouton.textContent = t('annuler', 'Annuler');
    bouton.addEventListener('click', annuler);
    zone.append(texte, bouton); zone.hidden = false;
  }
  function annuler() {
    if (!retire) return;
    var remettre = retire; retire = null;
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: remettre.id, quantity: remettre.qte }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (etat) {
        if (etat.status) { retire = remettre; return; }          /* erreur Shopify (stock…) : on garde l'annulation */
        drawer.classList.remove('is-empty');
        dernierPct = 0;                                          /* la jauge repart de zéro */
        if (typeof drawer.renderContents === 'function') drawer.renderContents(etat);
      })
      .catch(function () { retire = remettre; });
  }

  /* ---------- cadeaux des lots (03/10) ----------
     Règles posées par nky-offres.js (localStorage « nky-cadeaux » : produit -> [{ v: variante offerte, p: palier }]).
     Une ligne cadeau porte la propriété « _cadeau » : retirée si le produit n'atteint plus le palier, remise s'il l'atteint
     de nouveau, gardée au nombre de paliers atteints (1 en général ; 2 si le même article est offert à 2 paliers), sans boutons (la remise de lot Shopify exige le cadeau dans le panier : le retirer à la main
     ferait perdre la remise). Un achat normal du même article (sans « _cadeau ») n'est jamais touché. */
  var racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cadeauxEnCours = false;
  function regles() { try { return JSON.parse(localStorage.getItem('nky-cadeaux') || '{}'); } catch (e) { return {}; } }
  function estCadeau(i) { return !!(i.properties && i.properties._cadeau); }
  /* le client a choisi une offre sans cadeau pour ce produit (nky-offres.js) : on n'en ajoute pas, on ajuste seulement ceux présents */
  function sansCadeau(pid) { try { return sessionStorage.getItem('nky-sans-cadeau-' + pid) === '1'; } catch (e) { return false; } }
  function marquer(panier) {
    var lignes = drawer.querySelectorAll('.cart-item');
    panier.items.forEach(function (i, n) { if (lignes[n]) lignes[n].classList.toggle('nky-ligne-cadeau', estCadeau(i)); });
  }
  function redessiner() {
    var parts = drawer.getSectionsToRender ? drawer.getSectionsToRender() : [];
    if (!parts.length) return Promise.resolve();
    return fetch(window.location.pathname + '?sections=' + parts.map(function (x) { return x.id; }).join(','))
      .then(function (r) { return r.json(); })
      .then(function (html) {
        parts.forEach(function (x) {
          var el = x.selector ? document.querySelector(x.selector) : document.getElementById(x.id);
          if (el && html[x.id] && drawer.getSectionInnerHTML) el.innerHTML = drawer.getSectionInnerHTML(html[x.id], x.selector);
        });
      });
  }
  function cadeaux() {
    var R = regles();
    if (cadeauxEnCours || !Object.keys(R).length) return;
    cadeauxEnCours = true;
    fetch(racine + 'cart.js').then(function (r) { return r.json(); }).then(function (panier) {
      var ajouts = [], maj = {};
      Object.keys(R).forEach(function (pid) {
        var qte = panier.items.filter(function (i) { return String(i.product_id) === pid && !estCadeau(i); })
                              .reduce(function (a, i) { return a + i.quantity; }, 0);
        /* un même article peut être offert à plusieurs paliers (09/10 : 1 pyjama par ceinture, 2 pour 2) :
           quantité voulue = nombre de paliers atteints */
        var voulu = {};
        (R[pid] || []).forEach(function (c) { voulu[c.v] = (voulu[c.v] || 0) + (qte >= c.p ? 1 : 0); });
        Object.keys(voulu).forEach(function (v) {
          var n = voulu[v], ligne = panier.items.filter(function (i) { return i.variant_id === +v && estCadeau(i); })[0];
          if (n > 0 && !ligne) { if (!sansCadeau(pid)) ajouts.push({ id: +v, quantity: n, properties: { _cadeau: 'lot' } }); }
          else if (ligne && ligne.quantity !== n) maj[ligne.key] = n;
        });
      });
      if (!ajouts.length && !Object.keys(maj).length) { marquer(panier); return; }
      var json = { 'Content-Type': 'application/json', Accept: 'application/json' };
      var etape = Object.keys(maj).length
        ? fetch(racine + 'cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ updates: maj }) })
        : Promise.resolve();
      return etape.then(function () {
        return ajouts.length ? fetch(racine + 'cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: ajouts }) }) : null;
      }).then(redessiner);
    }).catch(function () {}).finally(function () { cadeauxEnCours = false; });
  }

  /* ---------- cures au sachet (25/10, gummies « Cure 3 mois » = 1 ligne de 3 sachets) ----------
     nky-offres.js pose « _paliers » (« 1=id;2=id;3=id ») sur la ligne. Quand le client change la quantité, la ligne passe sur la
     variante du plus grand palier atteint (2 sachets = prix de la cure 2 mois, 4 et plus = prix de la cure 3 mois) : le prix
     suit la quantité, sans remise Shopify. Ajout de la nouvelle ligne d'abord, retrait de l'ancienne ensuite (rien n'est perdu
     si l'ajout échoue). Les autres lignes ne sont jamais touchées. */
  var curesEnCours = false;
  function cures() {
    if (curesEnCours) return;
    curesEnCours = true;
    var json = { 'Content-Type': 'application/json', Accept: 'application/json' };
    fetch(racine + 'cart.js').then(function (r) { return r.json(); }).then(function (panier) {
      var ajouts = [], retraits = {};
      panier.items.forEach(function (i) {
        var p = i.properties && i.properties._paliers;
        if (!p) return;
        var palier = 0, cible = 0;
        p.split(';').forEach(function (s) {
          var kv = s.split('='), n = +kv[0];
          if (n <= i.quantity && n > palier) { palier = n; cible = +kv[1]; }
        });
        if (!cible || cible === i.variant_id) return;
        ajouts.push({ id: cible, quantity: i.quantity, properties: i.properties });
        retraits[i.key] = 0;
      });
      if (!ajouts.length) return;
      return fetch(racine + 'cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: ajouts }) })
        .then(function (r) { if (!r.ok) throw r; })
        .then(function () { return fetch(racine + 'cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ updates: retraits }) }); })
        .then(redessiner);
    }).catch(function () {}).finally(function () { curesEnCours = false; });
  }

  /* ---------- rebranchement après chaque rendu Shopify ---------- */
  var enAttente = false;
  function apresRendu() {
    enAttente = false;
    var tete = $('.drawer__header');
    if (!tete || tete.dataset.nkyVu) return;                   /* déjà traité : ce n'est pas un nouveau rendu */
    tete.dataset.nkyVu = '1';
    if (!drawer.classList.contains('is-empty')) retire = null;
    proposerAnnulation();
    if (ouvert()) { jauge(dernierPct, 20); livraison(); demarrerReserve(); }
    cadeaux();
    cures();
  }
  new MutationObserver(function () {
    if (!enAttente) { enAttente = true; requestAnimationFrame(apresRendu); }
  }).observe(drawer, { childList: true, subtree: true });

  /* ---------- ouverture / fermeture ----------
     Dawn change aussi « is-empty » pendant que le panier est ouvert : on ne rejoue l'animation
     qu'au vrai passage fermé → ouvert. */
  var etaitOuvert = ouvert();
  new MutationObserver(function () {
    var o = ouvert();
    if (o && !etaitOuvert) { jauge(0, 220); livraison(); demarrerReserve(); }
    else if (!o && etaitOuvert) clearInterval(reserveTic);
    if (o) proposerAnnulation();
    etaitOuvert = o;
  }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

  /* état initial : jauge posée, minuteur prêt (le panneau est fermé) */
  var tete = $('.drawer__header'); if (tete) tete.dataset.nkyVu = '1';
  var j = $('.nky-jauge'); dernierPct = j ? parseFloat(j.dataset.nkyPct) || 0 : null;
  livraison();
  reserveChrono();
  cadeaux();
  cures();
})();
